import React, { useState } from 'react'
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react'
import {
	Table,
	TableHeader,
	TableRow,
	TableHead,
} from 'components/ui/table'

export default function useTableNoPage(records, headerCells, filterFn) {
	const page = 0
	const rowsPerPage = 9999999
	const [order, setOrder] = useState()
	const [orderBy, setOrderBy] = useState()

	const TblContainer = props => (
		<div className="overflow-x-auto w-full" style={{ WebkitOverflowScrolling: 'touch' }}>
			<Table
				className="[&_thead_th]:font-semibold [&_thead_th]:text-[#444] [&_thead_th]:border-b-2 [&_thead_th]:border-b-[#027fff] [&_thead_th]:whitespace-nowrap [&_thead_th:hover_span]:text-[#444] [&_tbody_td]:font-normal [&_tbody_tr:hover]:bg-[#fffbf2] [&_tbody_tr:hover]:cursor-pointer"
			>
				{props.children}
			</Table>
		</div>
	)

	const TblHeader = props => {
		const handleSortRequest = cellId => {
			const isAsc = orderBy === cellId && order === 'asc'
			setOrder(isAsc ? 'desc' : 'asc')
			setOrderBy(cellId)
		}

		return (
			<TableHeader>
				<TableRow>
					{headerCells.map(headerCell => (
						<TableHead
							key={headerCell.id}
							style={headerCell.align ? { textAlign: headerCell.align } : undefined}
						>
							{headerCell.disableSorting ? (
								headerCell.label
							) : (
								<button
									type="button"
									className="inline-flex items-center gap-1 cursor-pointer bg-transparent border-none p-0 font-semibold text-[#444] hover:text-[#222]"
									onClick={() => handleSortRequest(headerCell.id)}
								>
									{headerCell.label}
									{orderBy === headerCell.id ? (
										order === 'desc' ? (
											<ArrowDown className="w-3.5 h-3.5" />
										) : (
											<ArrowUp className="w-3.5 h-3.5" />
										)
									) : (
										<ArrowUpDown className="w-3.5 h-3.5 opacity-30" />
									)}
								</button>
							)}
						</TableHead>
					))}
				</TableRow>
			</TableHeader>
		)
	}

	function stableSort(array, comparator) {
		const stabilizedThis = array.map((el, index) => [el, index])
		stabilizedThis.sort((a, b) => {
			const order = comparator(a[0], b[0])
			if (order !== 0) return order
			return a[1] - b[1]
		})
		return stabilizedThis.map(el => el[0])
	}

	function getComparator(order, orderBy) {
		return order === 'desc'
			? (a, b) => descendingComparator(a, b, orderBy)
			: (a, b) => -descendingComparator(a, b, orderBy)
	}

	function descendingComparator(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1
		}
		if (b[orderBy] > a[orderBy]) {
			return 1
		}
		return 0
	}

	const recordsAfterPagingAndSorting = () => {
		return stableSort(filterFn.fn(records), getComparator(order, orderBy)).slice(
			page * rowsPerPage,
			(page + 1) * rowsPerPage,
		)
	}

	return {
		TblContainer,
		TblHeader,
		recordsAfterPagingAndSorting,
	}
}
